// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var TCSSource;
(function (TCSSource) {
    TCSSource[TCSSource["Unknown"] = 0] = "Unknown";
    TCSSource[TCSSource["Patient"] = 5] = "Patient";
    TCSSource[TCSSource["Provider"] = 6] = "Provider";
    TCSSource[TCSSource["Hub"] = 7] = "Hub";
    TCSSource[TCSSource["Express"] = 8] = "Express";
    TCSSource[TCSSource["OpusMigration"] = 10] = "OpusMigration";
})(TCSSource || (TCSSource = {}));
//# sourceMappingURL=tCSSource.js.map